export const propertyBlacklist = ['OGR_STYLE', 'alignment'];
